import styles from './HamburgerMorphIcon.module.css';

/**
 * The ☰ ↔ ✕ morph, shared by the desktop "More" toggle, the mobile hamburger
 * (both in Header.tsx) and the drawer's own close button — all 32×32 boxes — so
 * open/close morphs identically everywhere instead of hard-swapping two static
 * SVGs. Transform-only, reduced-motion gated.
 *
 * Its own module because MobileDrawer is imported BY Header; importing the icon
 * back from Header would be a cycle.
 */
export const HamburgerMorphIcon = ({ open }: { open: boolean }) => {
  const bar = (which: 'top' | 'bottom') =>
    [styles.bar, styles[which], open ? styles.open : ''].filter(Boolean).join(' ');

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <g className={bar('top')}>
        <line x1="7.5" y1="15.5" x2="24.5" y2="15.5" />
      </g>
      <g className={bar('bottom')}>
        <line x1="7.5" y1="15.5" x2="24.5" y2="15.5" />
      </g>
    </svg>
  );
};
